// FETCH KB HUB
export const FETCH_KB_HUB = 'state.actions.fetch-knowledge-hub.FETCH_KB_HUB' as const;

export type FetchKbHubPayload = {
	projectKey: string;
};

export type FetchKbHubAction = {
	type: typeof FETCH_KB_HUB;
	payload: FetchKbHubPayload;
};

export const fetchKnowledgeHub = (projectKey: string): FetchKbHubAction => ({
	type: FETCH_KB_HUB,
	payload: {
		projectKey,
	},
});
